export var STRIPE_PAYMENT_METHODS = {
  CARD: 'card',
  SEPA: 'sepa',
  IDEAL: 'ideal'
};
export var DEFAULT_PAYMENT_METHOD_ID = STRIPE_PAYMENT_METHODS.CARD;